import { useRef, useState } from "react";
import { ChatStatus } from "../../../entities/chat-support.entity";
import { SlOptionsVertical } from "react-icons/sl";
import { useChatSupport } from "../../../context/chat-support/chat-support.context";
import { useOutsideClick } from "../../../customHooks/use-outside-click";

type Props = {
  status: ChatStatus;
};

export const ActiveChatHeaderMenu = ({ status }: Props) => {
  const { actions } = useChatSupport();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const closeMenu = () => {
    if (!isOpen) return;
    setIsOpen(false);
  };
  useOutsideClick(menuRef, closeMenu, isOpen, [isOpen]);
  return (
    <div ref={menuRef} className="relative z-50 ">
      <div className="size-8 flex_center  rounded-full   hover:bg-gray-200 ">
        <SlOptionsVertical className="cursor-pointer" onClick={() => setIsOpen(!isOpen)} />
      </div>

      <div
        className={`absolute w-[150px] bg-white p-2 z-50 end-[2px] top-7  drop-shadow-md rounded-md ${
          isOpen ? "flex flex-col" : "hidden"
        }`}
      >
        <span
          onClick={() => {
            actions.changeChatStatus(status === ChatStatus.OPEN ? ChatStatus.CLOSED : ChatStatus.OPEN);
            setIsOpen(false);
          }}
          className="text-gray-800 p-1  px-2 rounded-md cursor-pointer hover:bg-gray-100 "
        >
          Mark As {status === ChatStatus.OPEN ? "Closed" : "Open"}
        </span>
      </div>
    </div>
  );
};
